var exports = {
  "iW": "xe533113f--d7e7ab--company-name",
  "hn": "xe533113f--d7e7ab--company-name-title",
  "L1": "xe533113f--d7e7ab--content-title",
  "D1": "xe533113f--d7e7ab--content-col",
  "PN": "xe533113f--d7e7ab--contact-item",
  "pD": "xe533113f--d7e7ab--justify",
  "Qs": "xe533113f--d7e7ab--content",
  "M3": "xe533113f--d7e7ab--contacts",
  "$X": "xe533113f--d7e7ab--worktime",
};

module.exports = exports;
